import axios from "axios";

axios.defaults.baseURL = process.env.REACT_APP_BASE_URL;

axios.defaults.headers["x-access-token"] =
    localStorage.getItem(`x-access-token`) || ``;
axios.defaults.headers["x-dashboard-staffid"] =
    localStorage.getItem(`x-dashboard-staffid`) || ``;

axios.interceptors.request.use(
    function (config) {
        if (
            config.url === "/users/login" ||
            config.url == "/users/forgetPassword" ||
            config.url.includes("/verify-password")
        ) {
            delete axios.defaults.headers["x-access-token"];
            delete axios.defaults.headers["x-dashboard-staffid"];
        }
        return config;
    },
    function (error) {
        // Do something with request error
        return Promise.reject(error);
    },
);

axios.interceptors.response.use(
    function (config) {
        if (
            config.config.url === "/users/login" &&
            config.status === 200 &&
            config.data.success
        ) {
            const { data } = config.data;
            axios.defaults.headers["x-access-token"] = data.token;
            axios.defaults.headers["x-dashboard-staffid"] = data.user?.id;
            localStorage.setItem(`x-access-token`, data.token);
            localStorage.setItem(`userRoleId`, data.user?.role_id);
            localStorage.setItem(`x-dashboard-staffid`, data.user?.id);
            localStorage.setItem(`userFirstname`, data.user?.first_name);
            localStorage.setItem(`loggedIn`, true);
        }
        return config;
    },
    function (error) {
        // Do something with request error
        return Promise.reject(error);
        // return error;
    },
);

export default function HTTP(url, data = {}, method = "POST") {
    return new Promise((resolve, reject) => {
        axios({
            method,
            url,
            data,
        })
            .then(function (response) {
                if (
                    !response.data?.success &&
                    response.data?.err_code === "ERR_TOKEN_AUTH_USER"
                ) {
                    localStorage.clear();
                    window.location.reload();
                }
                if (response.data?.err_code) {
                    return reject(response.data?.message);
                }
                // handle success
                return resolve(response.data);
            })
            .catch(function (error) {
                // handle error
                if (
                    (error.config.url =
                        "/users/login" && error.response?.data?.success === 0)
                ) {
                    return resolve(error.response.data);
                }
                return reject(error);
            });
    });
}
